import { authApi } from './auth'
import { myCruzApi } from './myCruz'
import { userApi } from './user'
import { contactApi } from './contact'
import { otherApi } from './other'
import { spottedApi } from './spotted'
import { statApi } from './stat'
import { vehicleApi } from './vehicle'
import { vendorApi } from './vendor'
import { metaApi } from './meta'
import { researchApi } from './research'

export {
  authApi,
  myCruzApi,
  userApi,
  contactApi,
  otherApi,
  spottedApi,
  statApi,
  vehicleApi,
  vendorApi,
  metaApi,
  researchApi,
}
